import { render, staticRenderFns } from "./SubLayout.vue?vue&type=template&id=6bfcd4ec&scoped=true&"
import script from "./SubLayout.vue?vue&type=script&lang=js&"
export * from "./SubLayout.vue?vue&type=script&lang=js&"
import style0 from "./SubLayout.vue?vue&type=style&index=0&id=6bfcd4ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfcd4ec",
  null
  
)

export default component.exports